import React from "react";
import { Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";

// Register ChartJS components
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
);

const ProjectDashboard = () => {
  // Mock data for projects with progress
  const projects = [
    {
      name: "ehslbly-frontend",
      status: "Private",
      language: "JavaScript",
      stars: 2,
      lastUpdated: "17 hours ago",
      progress: 75,
      tasks: {
        completed: 15,
        total: 20,
      },
    },
    {
      name: "ehslbly-backend",
      status: "Private",
      language: "JavaScript",
      stars: 2,
      lastUpdated: "17 hours ago",
      progress: 60,
      tasks: {
        completed: 12,
        total: 20,
      },
    },
    {
      name: "mobile-app-backend",
      status: "Private",
      language: "JavaScript",
      stars: 2,
      lastUpdated: "yesterday",
      progress: 45,
      tasks: {
        completed: 9,
        total: 20,
      },
    },
    {
      name: "Ehsibly-Electron",
      status: "Private",
      language: "JavaScript",
      stars: 1,
      lastUpdated: "2 days ago",
      progress: 30,
      tasks: {
        completed: 6,
        total: 20,
      },
    },
    {
      name: "ehslbly-native",
      status: "Public",
      language: "JavaScript",
      stars: 0,
      lastUpdated: "Feb 19",
      progress: 90,
      tasks: {
        completed: 18,
        total: 20,
      },
    },
    {
      name: "al-habbar-frontend-test",
      status: "Public",
      language: "Not specified",
      stars: 0,
      lastUpdated: "Unknown",
      progress: 10,
      tasks: {
        completed: 2,
        total: 20,
      },
    },
  ];

  // Chart data for progress bars
  const getProgressChartData = (progress) => ({
    labels: ["Progress"],
    datasets: [
      {
        label: "Completion %",
        data: [progress],
        backgroundColor: [
          progress > 70 ? "#4CAF50" : progress > 40 ? "#FFC107" : "#F44336",
        ],
        borderColor: [
          progress > 70 ? "#388E3C" : progress > 40 ? "#FFA000" : "#D32F2F",
        ],
        borderWidth: 1,
      },
    ],
  });

  // Chart options for progress bars
  const progressChartOptions = {
    indexAxis: "y",
    scales: {
      x: {
        max: 100,
        min: 0,
        ticks: {
          stepSize: 20,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    maintainAspectRatio: false,
  };

  // Chart data for task completion pie charts
  const getTaskChartData = (completed, total) => ({
    labels: ["Completed", "Remaining"],
    datasets: [
      {
        data: [completed, total - completed],
        backgroundColor: ["#4CAF50", "#E0E0E0"],
        borderColor: ["#388E3C", "#BDBDBD"],
        borderWidth: 1,
      },
    ],
  });

  return (
    <div
      className="project-dashboard"
      style={{
        fontFamily: "Arial, sans-serif",
        maxWidth: "800px",
        margin: "0 auto",
      }}
    >
      <h1 style={{ color: "#333", textAlign: "center" }}>Project Dashboard</h1>
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            style={{
              padding: "5px 10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
          >
            Type ▼
          </button>
          <button
            style={{
              padding: "5px 10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
          >
            Language ▼
          </button>
          <button
            style={{
              padding: "5px 10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
          >
            Sort ▼
          </button>
        </div>
        <input
          type="text"
          placeholder="Find a repository..."
          style={{
            padding: "5px 10px",
            borderRadius: "4px",
            border: "1px solid #ddd",
            width: "250px",
          }}
        />
      </div>

      <div
        style={{
          border: "1px solid #ddd",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        {projects.map((project, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "15px",
              borderBottom:
                index < projects.length - 1 ? "1px solid #eee" : "none",
              backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white",
            }}
          >
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                {project.name}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  fontSize: "0.9em",
                  color: "#666",
                }}
              >
                <span>
                  {project.status === "Private" ? "● Private" : "Public"}
                </span>
                <span>{project.language}</span>
                <span>{project.stars > 0 ? `☆ ${project.stars}` : ""}</span>
                <span>Updated {project.lastUpdated}</span>
              </div>
            </div>

            <div style={{ width: "150px", height: "30px", margin: "0 15px" }}>
              <Bar
                data={getProgressChartData(project.progress)}
                options={progressChartOptions}
              />
            </div>

            <div style={{ width: "50px", height: "50px" }}>
              <Pie
                data={getTaskChartData(
                  project.tasks.completed,
                  project.tasks.total
                )}
                options={{
                  plugins: { legend: { display: false } },
                  maintainAspectRatio: false,
                }}
              />
            </div>

            <div style={{ marginLeft: "15px", textAlign: "center" }}>
              <div style={{ fontWeight: "bold" }}>{project.progress}%</div>
              <div style={{ fontSize: "0.8em", color: "#666" }}>
                {project.tasks.completed}/{project.tasks.total} tasks
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectDashboard;
